import module from 'module';
import $ from '../jquery';
import Spaces from '../spacesLib';
import { L } from '../core/l10n';
import {copyToClipboard} from '../core/clipboard';
import { canShare, share } from '../core/share';
import { closeAllPoppers } from './popper';

function init(container) {
	// Скрываем "Поделиться с помощью..", если платформа не поддерживает
	container.on('popper:beforeOpen', '.js-share_menu', function () {
		const menu = $(this);
		menu.find('[data-action="share_external"]').toggleClass('hide', !canShare());
		menu.find('[data-action="save_to_collections"]').addClass('hide');
	});
	
	container.action('share_external', function (e) {
		e.preventDefault();
		share({url: getObjectUrl($(this))});
	}).action('copy_link', function (e) {
		e.preventDefault();
		e.stopPropagation();
		
		let el = $(this);
		let url = getObjectUrl(el);
		
		let set_status = (flag) => {
			el.find('.js-text').text(flag ? L('Скопировать ссылку (скопировано)') : L('Скопировать ссылку'));
			el.find('.js-ico').toggleClass("ico_mail ico_mail_link", !flag).toggleClass("ico ico_ok_green", flag);
		};
		
		// Копируем в буфер браузера
		copyToClipboard(url);
		
		// Копируем в буфер сайта
		if (Spaces.params.nid) {
			Spaces.api("common.copyURL", {
				url:	url,
				CK:		null
			});
		}
		
		set_status(true);
		
		setTimeout(() => {
			set_status(false);
			closeAllPoppers();
		}, 1500);
	}).action('cancel', function (e) {
		closeAllPoppers();
	});
}

module.on('componentpage', () => {
	init($('#main'));
});

function getObjectUrl(link) {
	return $('#Gallery').data('objectUrl') || link.parents('.js-action_bar').data('objectUrl');
}

export { init };
